import Boto from '../Boto/Boto';
import styles from './calltoaction.module.scss';
import clsx from 'clsx';

const CallToAction = (props) => {
    const { titol, text, boto, estil, id } = props;

    const stylesContent = clsx({
        [styles.content]: true,
        [styles[estil]]: !!estil
    });

    const stylesBoto = clsx({
        [styles.boto]: true,
        [styles[boto?.estil]]: !!estil
    });
    return (
        <div className={stylesContent} data-testid={`call-to-action-${id}`}>
            {titol && <h3 data-testid={`call-to-action-${id}-titol`}>{titol}</h3>}
            {text && (
                <p data-testid={`call-to-action-${id}-text`} className={styles.entrada}>
                    {text}
                </p>
            )}

            {boto && (
                <Boto
                    link={boto.href}
                    route={boto.route}
                    className={stylesBoto}
                    text={boto.text}
                    icona={boto.icona}
                    novaFinestra={boto.novaFinestra}
                    isIconaBlanc={boto.iconaBlanc}
                    altIcona={boto.text}
                    dataTestId={`call-to-action-${id}-boto`}
                    isIconaDreta={boto.iconaDreta}
                    fons={boto.fons}
                />
            )}
        </div>
    );
};

export default CallToAction;
